module.exports = __webpack_public_path__ + "static/media/cable.6b057304.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/cable.svg
// module id = 119
// module chunks = 0